"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.MultiColumnSorting = void 0;
var _multiColumnSorting = require("./multiColumnSorting");
exports.PLUGIN_KEY = _multiColumnSorting.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _multiColumnSorting.PLUGIN_PRIORITY;
exports.MultiColumnSorting = _multiColumnSorting.MultiColumnSorting;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/multiColumnSorting/index.js
// module id = 1493
// module chunks = 0